import { type AppManager, ConnectionAppManager, Variables } from 'core/index';

import { ContributionArrayApp } from 'apps/repository/app';
import { action, untracked } from 'mobx';
import { ContributionsSidebarQuery } from './gql';

export class ExtensibleConnectionAppManager extends ConnectionAppManager {
  // This is a hack to be able to extend this.process in subclasses.
  // The difficulty is that arrow functions cannot be extended
  // (That is: can't be overriden and call the super implementation)
  // This is just an alias so subclasses can call "this.parentProcess()"
  // instead of the invalid "super.process()"
  // Because of order of initialization of subclassing this is executed when the
  // ConnectionAppManager.process is already intialized but the subclass has not
  // overriden it yet, so we can keep a reference to the implementation we want here.
  parentProcess = this.process;
  parentMoreData = this.moreData;
}

export class ContributionSidebarConnManager extends ExtensibleConnectionAppManager {
  static ArrayApp = ContributionArrayApp;

  projectId: string;
  path: string;

  constructor(parent: AppManager, init: any, options: any) {
    super(parent, init, options);
    this.initialBatchSize = 5;
    this.batchSize = 5;
    this.variables = new Variables({
      projectId: () => this.projectId,
      path: () => this.path,
      batchSize: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
      cursor: () => this.endCursor,
      sortBy: () => 'recent',
      //   basepath: () => this.path,
    });
    this.loadMoreQuery = ContributionsSidebarQuery;
  }

  @action process = (queryResult: any) => {
    if (queryResult) {
      // We change the ID to avoid collision in the Model Cache because the
      // contribution.files array has a single file in this gql due
      // to the basename param/resolver and that would override the previous
      // contents of the contribution.files which contains all the files for the
      // latest contribution being rendered
      queryResult.edges.forEach((edge: any) => {
        untracked(() => {
          // This is always true, just a sanity check in case future
          // issue with mobx recursion.
          if (!edge.node.id.startsWith('sidebar-')) {
            // eslint-disable-next-line no-param-reassign
            edge.node.id = `sidebar-${edge.node.id}`;
          }
        });
      });
    }
    return this.parentProcess(queryResult);
  };

  @action moreData = (result: any, query: any) => {
    if (result !== null) {
      // remove the sidebar- prefix
      result.edges.forEach((edge: any) => {
        untracked(() => {
          // eslint-disable-next-line no-param-reassign
          edge.node.id = edge.node.id.replace('sidebar-', '');
        });
      });
    }
    return this.parentMoreData(result, query);
  };
}
